import axios from '@/libs/api.request'

export const getTableData = (data) => {
  return axios.request({
    url: '/datacenter/data',
    method: 'post',
    data
  })
}

export const getTableDataColor = (data) => {
  return axios.request({
    url: '/datacenter/data/color',
    method: 'post',
    data
  })
}

export const getDataInit = () => {
  return axios.request({
    url: '/datacenter/data/init',
    method: 'get'
  })
}

export const getPlayData = (params) => {
  return axios.request({
    url: '/datacenter/data/play',
    method: 'get',
    params
  })
}

export const getPersonInit = () => {
  return axios.request({
    url: '/datacenter/dict/mediabuy_name',
    method: 'get'
  })
}

export const getCampainInit = (params) => {
  return axios.request({
    url: '/datacenter/data/fb/campaign/query',
    method: 'get',
    params
  })
}

export const getCampainInitNew = (params) => {
  return axios.request({
    url: '/datacenter/data/fb/campaign/query',
    method: 'get',
    params
  })
}

export const getSetInit = (params) => {
  return axios.request({
    url: '/datacenter/data/fb/ad/set/query',
    method: 'get',
    params
  })
}

export const getAdInit = (params) => {
  return axios.request({
    url: '/datacenter/data/fb/ad/query',
    method: 'get',
    params
  })
}

export const gePitcherData = (data) => {
  return axios.request({
    url: '/datacenter/data/advertise',
    method: 'post',
    data
  })
}

export const gePitcherDataColor = (data) => {
  return axios.request({
    url: '/datacenter/data/advertise/coloration',
    method: 'post',
    data
  })
}
export const changePitcherStatus = (id) => {
  return axios.request({
    url: '/datacenter/data/advertise/coloration/status/'+id,
    method: 'get',
  })
}
export const gePlayDataColor = (params) => {
  return axios.request({
    url: '/datacenter/data/play/coloration',
    method: 'get',
    params
  })
}

export const exportPitcherDataColor = (data) => {
  return axios.request({
    url: '/datacenter/data/advertise/coloration/export',
    method: 'post',
    data
  })
}

export const exportPitcherData = (data) => {
  return axios.request({
    url: '/datacenter/data/advertise/export',
    method: 'post',
    data
  })
}


export const getPitcherCampaign = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/campaign',
    method: 'post',
    data
  })
}

export const getPitcherAdSetPage = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/adSet',
    method: 'post',
    data
  })
}

export const getPitcherAdPage = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/ad',
    method: 'post',
    data
  })
}

export const getPitcherAdSet = (params)=>{
  return axios.request({
    url: '/datacenter/data/fb/ad/set/query',
    method: 'get',
    params
  })
}

export const getPitcherAddress = (params)=>{
  return axios.request({
    url: '/datacenter/data/fb/ad/query',
    method: 'get',
    params
  })
}

export const getPitcherData = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/optimizer',
    method: 'post',
    data
  })
}

export const getLang = (params)=>{
  return axios.request({
    url: '/datacenter/lang/page',
    method: 'get',
    params
  })
}

export const exportPitcher = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/optimizer/export',
    method: 'post',
    data
  })
}

export const exportCampaign = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/campaign/export',
    method: 'post',
    data
  })
}

export const exportAdSet = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/adSet/export',
    method: 'post',
    data
  })
}

export const exportAd = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/ad/export',
    method: 'post',
    data
  })
}
export const getPlay = (params)=>{
  return axios.request({
    url: '/datacenter/pitcher/query_play_combobox',
    method: 'get',
    params
  })
}

export const getPlayDataNew = (params) => {
  return axios.request({
    url: '/datacenter/data/play/new',
    method: 'get',
    params
  })
}


export const gePlayDataColorNew = (params) => {
  return axios.request({
    url: '/datacenter/data/play/new/coloration',
    method: 'get',
    params
  })
}

export const getHourData = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/campaign/hour',
    method: 'post',
    data
  })
}

export const getCountryData = (data)=>{
  return axios.request({
    url: '/datacenter/pitcher/campaign/country',
    method: 'post',
    data
  })
}

export const getDataNew = (data)=>{
  return axios.request({
    url: '/datacenter/data_overview',
    method: 'post',
    data
  })
}

export const exportData = (data)=>{
  return axios.request({
    url: '/datacenter/data_overview/export',
    method: 'post',
    data
  })
}

// 短剧数据汇总报表查询
export const getPlayStatData = (data) => {
  return axios.request({
    url: '/datacenter/data/play/stat/',
    method: 'post',
    data
  })
}

// 短剧数据汇总报表查询 - 导出
export const exportPlayStatData = (data) => {
  return axios.request({
    url: '/datacenter/data/play/stat/export',
    method: 'post',
    data
  })
}

// 短剧数据语言表现报表查询
export const getPlayStatLangData = (data) => {
  return axios.request({
    url: '/datacenter/data/play/stat/lang',
    method: 'post',
    data
  })
}

// 短剧数据语言表现报表查询 - 导出
export const exportPlayStatLangData = (data) => {
  return axios.request({
    url: '/datacenter/data/play/stat/lang/export',
    method: 'post',
    data
  })
}

// 短剧数据优化师维度报表查询
export const getPlayStatOptimizerData = (data) => {
  return axios.request({
    url: '/datacenter/data/play/stat/optimizer',
    method: 'post',
    data
  })
}

// 短剧数据优化师维度报表查询 - 导出
export const exportPlayStatOptimizerData = (data) => {
  return axios.request({
    url: '/datacenter/data/play/stat/optimizer/export',
    method: 'post',
    data
  })
}